import React, { Component } from 'react';
import styled from 'react-emotion';

import { Above } from '@jetshop/ui/Breakpoints';
import SortOrderDropdown from '@jetshop/ui/SortOrder/SortOrderDropdown';

import t from '@jetshop/intl';

import GridIcon from '../../icons/listning-ikoner-33x23px_boxar-std.png';
import GridIconHover from '../../icons/listning-ikoner-33x23px_boxar-mover.png';

import ListIcon from '../../icons/listning-ikoner-33x23px_listning-std.png';
import ListIconHover from '../../icons/listning-ikoner-33x23px_listning-mover.png';

import theme from '@jetshop/ui/utils/theme';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faAngleRight,
  faAngleDown,
  faSearch,
} from '@fortawesome/pro-light-svg-icons';
import FilterContext from '@jetshop/core/components/Filters/FilterContext';
library.add(faAngleRight, faAngleDown, faSearch);

const ToolBar = styled('menu')`
  display: flex;
  justify-content: space-between;
  align-items: center;
  ${theme('above.md')} {
    border-top: 1px solid #e6e6e6;
  }
  ${theme('below.md')} {
    padding: 0 1rem;
    margin-bottom: 5px;
  }
  padding: 10px 0 20px 10px;
  .toggleSelect {
    border: 0;
    h4 {
    }
  }
  .sortBy ~ svg {
    margin-left: -28px;
    vertical-align: middle;
    margin-top: 2px;
    font-size: 14px;
    ${theme('below.md')} {
      position: absolute;
      right: 30px;
    }
  }
`;

const YourModel = styled('span')`
  text-transform: uppercase;
  ${theme('below.md')} {
    display: none;
  }
`;

const RightArea = styled('aside')`
  display: flex;
  justify-content: space-between;
  width: auto;
  align-items: center;

  ${theme('below.md')} {
    margin: 0 auto;
    width: 100%;
  }

  .sortBy {
    margin: 0;
    background: none;
    ${theme('below.md')} {
      background: white;
    }
    > button {
      background: none;
      border: 1px solid transparent;
      text-transform: uppercase;
      &:focus {
        border-color: #ddd;
      }

      ${theme('below.md')} {
        height: 34px;
        border: 1px solid #9a9a9a;
      }
    }
    div button {
      background: white;
      text-transform: uppercase;
    }
  }
`;
const TogglerWrapper = styled('div')`
  display: flex;
  flex-direction: column;
  position: relative;
  > div {
    position: absolute;
    top: 150%;
    z-index: 999;
    background: #fff;
    border: 1px solid #000;
    display: flex;
    flex-direction: column;
    left: 16px;
    width: 100%;
  }
`;
const Toggler = styled('button')`
  font-size: 1.5rem;
  padding: 5px;
  position: relative;
  background: none;
  text-align: left;
  &:focus {
    outline: none;
  }
`;

const OpenDropdown = styled('span')`
  font-size: 14px;
  font-weight: 700;
  margin-left: 16px;
  padding-right: 16px;
  width: 105px;
  cursor: pointer;
  text-transform: uppercase;
  svg {
    vertical-align: middle;
    margin-left: 5px;
  }
`;

const TabButton = styled('button')`
  background: #e6e6e6;
  border: 1px solid #e6e6e6;
  margin-bottom: -1px;
  margin-right: -1px;
  padding: 1rem 2rem;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 1.2rem;
  color: #000000aa;
  opacity: 0.4;

  ${theme('below.md')} {
    font-size: 1rem;
    width: 50%;
    padding: 0;
    height: 40px;
    line-height: 40px;
    text-align: center;
    border: 1px solid #e6e6e6;
    background: #e6e6e6;
  }

  &:disabled {
    border-bottom: 1px solid #00b55b;
    color: #fff;
    background: #00b55b; //#f8f8f8;
    opacity: 1;
    ${theme('below.md')} {
      border: 1px solid #e6e6e6;
    }
  }
`;

const TabsWrapper = styled('div')`
  position: relative;
  ${theme('below.md')} {
    padding: 0 1rem;
    margin-bottom: 10px;
  }
`;

class CategoryToolbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dropdownOpen: false,
      currentView: 'grid',
      model: [],
      universal: this.props.universal,
    };
  }
  componentDidMount() {
    if (typeof window !== 'undefined') {
      if (typeof window.localStorage !== 'undefined') {
        if (localStorage.getItem('view')) {
          this.setState({ currentView: localStorage.getItem('view') });
        }
      }
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.currentView !== this.props.currentView) {
      if (typeof window !== 'undefined') {
        if (typeof window.localStorage !== 'undefined') {
          localStorage.setItem('view', this.props.currentView);
          this.setState({ currentView: this.props.currentView });
        }
      }
    }

    var activeFilters = this.props.activeFilters;

    if (
      activeFilters.multiListFilters.length === 1 &&
      activeFilters.multiListFilters[0].values &&
      activeFilters.multiListFilters[0].values.length === 3
    ) {
      var model = activeFilters.multiListFilters;
      if (JSON.stringify(model) !== JSON.stringify(this.state.model)) {
        this.setState({ model: model });
      }
    }
  }
  render() {
    const {
      changeView,
      modelSelected,
      hasSelector,
      filters,
      showUniversal,
      hideUniversal,
      universal,
    } = this.props;
    const { currentView } = this.state;
    var hasUniversalFilter =
      filters.length > 0 &&
      filters.filter((f) => f.id.indexOf('universal-del') > 0).length > 0;

    return (
      <FilterContext.Consumer>
        {({
          applyFilters,
          clearFilters,
          applyBoolFilter,
          activeFilters,
          applyMultiFilter,
        }) => (
          <>
            {hasUniversalFilter && modelSelected && hasSelector && (
              <TabsWrapper>
                <TabButton
                  disabled={!universal}
                  onClick={() => {
                    hideUniversal();
                  }}
                >
                  Passar din modell
                </TabButton>
                <TabButton
                  disabled={universal}
                  onClick={() => {
                    showUniversal();
                  }}
                >
                  Universaldelar
                </TabButton>
              </TabsWrapper>
            )}

            <ToolBar>
              <YourModel className="your-model">
                {' '}
                {modelSelected &&
                  hasSelector &&
                  !universal &&
                  'Passar din modell'}
                {modelSelected && hasSelector && universal && 'Universal'}
              </YourModel>

              <RightArea>
                <Above
                  breakpoint="md"
                  render={() => (
                    <TogglerWrapper>
                      <OpenDropdown
                        onClick={() => {
                          this.setState({
                            dropdownOpen: !this.state.dropdownOpen,
                          });
                        }}
                      >
                        {t('Select view')}
                        <FontAwesomeIcon icon={['fal', 'angle-down']} />
                      </OpenDropdown>
                      {this.state.dropdownOpen && (
                        <div>
                          <Toggler
                            onClick={() => {
                              this.setState({
                                dropdownOpen: !this.state.dropdownOpen,
                              });
                              changeView('grid');
                            }}
                          >
                            <img
                              className="grid-icon"
                              onClick={() => {
                                this.setState({
                                  dropdownOpen: !this.state.dropdownOpen,
                                });
                                changeView('grid');
                              }}
                              onMouseOver={(e) =>
                                (e.currentTarget.src = GridIconHover)
                              }
                              onMouseOut={(e) =>
                                currentView !== 'grid' &&
                                (e.currentTarget.src = GridIcon)
                              }
                              alt="Grid"
                              src={
                                (currentView !== 'list' && GridIconHover) ||
                                GridIcon
                              }
                            />
                          </Toggler>
                          <Toggler
                            onClick={() => {
                              this.setState({
                                dropdownOpen: !this.state.dropdownOpen,
                              });
                              changeView('list');
                            }}
                          >
                            <img
                              className="list-icon"
                              onClick={() => {
                                this.setState({
                                  dropdownOpen: !this.state.dropdownOpen,
                                });
                                changeView('list');
                              }}
                              onMouseOver={(e) =>
                                (e.currentTarget.src = ListIconHover)
                              }
                              onMouseOut={(e) =>
                                currentView !== 'list' &&
                                (e.currentTarget.src = ListIcon)
                              }
                              alt="List"
                              src={
                                (currentView !== 'grid' && ListIconHover) ||
                                ListIcon
                              }
                            />
                          </Toggler>
                        </div>
                      )}
                    </TogglerWrapper>
                  )}
                />
                <SortOrderDropdown
                  sortOrders={[
                    {
                      __typename: 'ProductSortOrder',
                      defaultDirection: 'DESCENDING',
                      text: 'Senast inkommet',
                      value: 'PUBLISH_DATE',
                    },
                    {
                      __typename: 'ProductSortOrder',
                      defaultDirection: 'DESCENDING',
                      text: 'Namn',
                      value: 'NAME',
                    },
                    {
                      __typename: 'ProductSortOrder',
                      defaultDirection: 'DESCENDING',
                      text: 'Pris',
                      value: 'PRICE',
                    },
                  ]}
                />
                <FontAwesomeIcon icon={['fal', 'angle-down']} />
              </RightArea>
            </ToolBar>
          </>
        )}
      </FilterContext.Consumer>
    );
  }
}
export default CategoryToolbar;
